import { validatorRequireNumber } from '@/utils/validators';
import MultiLanguageInput from '@/components/DSE/MultiLanguageInput';
import Switch from '@/components/DSE/Switch';
import Select from '@/components/DSE/Select';
import CrudVATTypeRates from './vattyperates/CrudVATTypeRates';
import MDinput from '@/components/MDinput';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'vat.rates'],
    headerTemplate: (str, form) => `
    <h3>
    ${vue.formatVatTypeOption(form.vatTypeOption) || ''}
    </h3>
    `,
    groups: [
      {
        // Tab 1
        vatTypeOption: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'vat.vatType',
            required: true,
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('vatType')
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        invoiceText: {
          type: MultiLanguageInput,
          props: {
            maxlength: 255,
            caption: 'vat.invoiceText'
          }
        },
        vatNumberRequiredYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'vat.vatNumberRequiredYN'
          }
        },
        taxCategoryCode: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 2,
            caption: 'vat.taxCategoryCode'
          }
        }
      },
      {
        // Tab 2
        vatTypeRates: {
          type: CrudVATTypeRates,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'vatTypeID',
            permissionCode: 'VatType'
          }
        }
      }
    ]
  };
}

export default getFormDefinition;

const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutFullWidth]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutFullWidth, layoutFullWidth]
  };
}
export function createItemFromFormData(vue, form) {
  return {
    ...form
  };
}

export function createFormDataFromItem(vue, item) {
  return {
    ...item
  };
}
